import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAccessibleReportsTabs } from '../constants/permissions';

interface ProtectedReportRouteProps {
  children: React.ReactNode;
  reportType: string;
  sectionId: 'event-status-report' | 'sales-performance-tracking' | 'profit-loss';
}

const ProtectedReportRoute: React.FC<ProtectedReportRouteProps> = ({ 
  children, 
  reportType,
  sectionId 
}) => {
  const location = useLocation();
  const { userDetails } = useSelector((state: any) => state.user);
  const userPermissions = userDetails?.role?.permissions || [];
  const userRole = userDetails?.role?.name;

  // Get all accessible reports tabs based on permissions
  const accessibleTabs: any = getAccessibleReportsTabs(userPermissions, userRole);
  
  // Check if the specific tab has VIEW permission (not edit)
  const tab = accessibleTabs.find((t: any) => t.sectionId === sectionId);
  const hasViewPermission = tab?.actions?.view ?? false;  // Changed from edit to view

  if (!hasViewPermission) {
    return <Navigate to="/report-management" state={{ 
      error: `You don't have permission to view ${reportType} details`,
      from: location.pathname 
    }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedReportRoute;